import el from "@cypherpotato/el";

export function TabControl(tabPages, options) {
    const isVertical = options?.type == "vertical";
    var tabControl = el(".tab-control",
        {
            classList: [
                isVertical ? "tab-control-vertical" : "tab-control-horizontal",
                options?.tabstripExtraPadded && "tab-control-tabstrip-extra-padded"
            ]
        },
        {
            $properties: {
                currentTab: {
                    get() {
                        return this.querySelector(":scope > .tab-control-tab-strip > .tab-item-toggle.tab-control-tab-selected")?.dataset.tabName;
                    },
                    set(value) {
                        this.querySelectorAll(":scope > .tab-control-tab-strip > .tab-item-toggle, :scope > .tab-control-body > .tab-control-tab-contents").forEach(tab => {
                            tab.classList.toggle("tab-control-tab-selected", tab.dataset.tabName === value);
                        });
                    }
                }
            }
        },
        el(".tab-control-tab-strip",
            ...tabPages.filter(n => n).map(tab =>
                el(".tab-item-toggle",
                    {
                        dataTabName: tab.title,
                        onClick() {
                            tabControl.currentTab = tab.title;
                        }
                    },
                    tab.icon && el(".tab-control-tab-icon", tab.icon),
                    !isVertical && el(".tab-control-tab-title", tab.title),
                )
            )
        ),
        el(".tab-control-body[height-target]",
            ...tabPages.map(tab =>
                el(".tab-control-tab-contents",
                    tab.contents,
                    {
                        dataTabName: tab.title
                    }
                )
            )
        )
    );

    tabControl.currentTab = tabPages[0].title;

    return tabControl;
}